"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Experimental cameras list is now empty
exports.default = [];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/tempCamerasOnPIR.js
 ** module id = 1409
 ** module chunks = 0
 **/